import styled from 'styled-components';

import {Input} from '../../../../components/Base/inputs/DynamicInput.styles';

export const CurrentValue = styled.span`
  color: white;
`;

export {Input};
